// Exports
export default {
	"premiumButton": "premiumButton_o4edN"
};
